import AsyncStorageBase from './base/AsyncStorageBase';
export default class AsyncStorage extends AsyncStorageBase{}